<template>
  <div class="jdwa-navbar-logo">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'JDWANavbarLogo',
  mounted() {
    // 适配新logo，微调样式
    const logo = document.querySelector('.navbar .logo');
    if (logo) {
      // 设置合适的样式
      logo.setAttribute('style', `
        height: 2.6rem !important;
        min-width: 2.6rem !important;
        max-height: none !important;
        margin-right: 0.8rem !important;
        position: relative !important;
        z-index: 100 !important;
      `);
      
      // 调整导航栏高度
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        navbar.setAttribute('style', `
          height: 4rem !important;
          line-height: 4rem !important;
          padding: 0.3rem 1.5rem !important;
        `);
      }
      
      // 监听暗黑模式切换
      const toggleButton = document.querySelector('.toggle-color-mode-button');
      if (toggleButton) {
        toggleButton.addEventListener('click', () => {
          // 给浏览器一点时间应用暗黑模式切换
          setTimeout(() => {
            if (document.documentElement.classList.contains('dark')) {
              // 暗黑模式下反转logo颜色
              logo.style.filter = 'invert(1)';
              logo.style.webkitFilter = 'invert(1)';
            } else {
              // 正常模式下移除反转
              logo.style.filter = '';
              logo.style.webkitFilter = '';
            }
          }, 50);
        });
      }
      
      // 初始检查是否为暗黑模式
      if (document.documentElement.classList.contains('dark')) {
        logo.style.filter = 'invert(1)';
        logo.style.webkitFilter = 'invert(1)';
      }
    }
  }
}
</script>

<style>
/* 适配新logo的样式 */
.navbar .logo,
.navbar a.home-link .logo {
  height: 2.6rem !important;
  min-width: 2.6rem !important;
  max-height: none !important;
  margin-right: 0.8rem !important;
  position: relative !important;
  z-index: 100 !important;
}

/* 暗黑模式下反转logo颜色 */
html.dark .navbar .logo,
html.dark .navbar a.home-link .logo {
  filter: invert(1) !important;
  -webkit-filter: invert(1) !important;
}

.navbar {
  height: 4rem !important;
  line-height: 4rem !important;
  padding: 0.3rem 1.5rem !important;
}
</style> 